<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3>Location: {{location}}</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<!--<b-button variant="dark" @click="downloadcsv()">Export</b-button>-->
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div style="border-top: 3px solid #333; border-radius: 5px; min-height: 100px; background-color: #FFF; display: flex; flex-direction: column;">
						<b-row class="mt-4 px-3 mb-3">
							<b-col lg="6">
								<label class="mr-2">Show</label>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(output_status)="row">
										<b-badge pill variant="success" v-if="row.value == 1">ON</b-badge>
										<b-badge pill variant="danger" v-else>OFF</b-badge>
									</template>
									<template v-slot:cell(supply)="row">
										<img src="../assets/power-on.svg" v-if="row.value == 'ON'" style="max-width:20px; max-height:20px;">
										<img src="../assets/power-off.svg" v-else style="max-width:20px; max-height:20px;">
									</template>
									<template v-slot:cell(door_status)="row">
										<b-badge pill variant="danger" v-if="row.value == 1">OPENED</b-badge>
										<b-badge pill variant="success" v-else>CLOSED</b-badge>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3 mb-3">
							<b-col lg="6">
								<span class="mr-2">Showing {{(currentPage-1)*perPage}} to {{currentPage*perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="6">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header
	},
	mounted(){
		this.initload();
	},
	data() {
		var self = this;
		return{
			email: '',
			password: '',
			url: self.$session.get('apiurl')+'api/device-record',
			imeino: self.$route.params.imeino,
			location: '',
			records: [],
			device: {},
			fields: [
				{ key: 'supply', label: 'Power', sortable: true, sortDirection: 'desc',
					formatter: (value, key, item) => {
						var supply = 'ON';
						if(item.datalength == 59){
							supply = 'OFF';
						}
						return supply;
					}, 
				},
				{ key: 'voltage_r', label: 'Volt.R',
					formatter: (value) => { 
						if(self.device.meter_type === '1P'){
							return (value/10).toFixed(1);
						}

						if(parseInt(value/100) <= 80){
							value = 0;
						}
						//alert(self.device.meter_type);
						return (value/100).toFixed(2);
					},
				},
				{ key: 'voltage_y', label: 'Volt.Y',
					formatter: (value) => { 
						if(parseInt(value/100) <= 80){
							value = 0;
						}
						return (value/100).toFixed(2);
					},
				},

				{ key: 'voltage_b', label: 'Volt.B',
					formatter: (value) => { 
						if(parseInt(value/100) <= 80){
							value = 0;
						}
						return (value/100).toFixed(2);
					},
				},
				{ key: 'amp_r', label: 'Amp.R',
					formatter: (value, key, item) => { 
						if(self.device.meter_type === '1P'){
							return (value/100).toFixed(2);
						}
						if(item.output_status == 0 && parseInt(value/1000) < self.$root.correction_amp){
							value = 0;
						}
						if(parseInt(item.voltage_r/100) <= 80){
							value = 0;
						}
						return (value/1000).toFixed(1);
					},
				},
				{ key: 'amp_y', label: 'Amp.Y',
					formatter: (value, key, item) => { 
						if(item.output_status == 0 && parseInt(value/1000) < self.$root.correction_amp){
							value = 0;
						}
						if(parseInt(item.voltage_y/100) <= 80){
							value = 0;
						}
						return (value/1000).toFixed(1);
					},
				},
				{ key: 'amp_b', label: 'Amp.B',
					formatter: (value, key, item) => { 
						if(item.output_status == 0 && parseInt(value/1000) < self.$root.correction_amp){
							value = 0;
						}
						if(parseInt(item.voltage_b/100) <= 80){
							value = 0;
						}
						return (value/1000).toFixed(1);
					},
				},
				{ key: 'kw_r', label: 'KwR',
					formatter: (value, key, item) => { 
						if(self.device.meter_type === '1P'){
							return (value/10000).toFixed(3);
						}

						if(item.output_status == 0 && (parseInt(item.amp_r/1000) < self.$root.correction_amp)){
							value = 0;
						}
						if(parseInt(item.voltage_r/100) <= 80){
							value = 0;
						}
						return (value/100000).toFixed(2);
					},
				},
				{ key: 'kw_y', label: 'KwY',
					formatter: (value, key, item) => { 
						if(item.output_status == 0 && (parseInt(item.amp_y/1000) < self.$root.correction_amp)){
							value = 0;
						}
						if(parseInt(item.voltage_y/100) <= 80){
							value = 0;
						}
						return (value/100000).toFixed(2);
					},
				},
				{ key: 'kw_b', label: 'KwB',
					formatter: (value, key, item) => { 
						if(item.output_status == 0 && (parseInt(item.amp_b/1000) < self.$root.correction_amp)){
							value = 0;
						}
						if(parseInt(item.voltage_b/100) <= 80){
							value = 0;
						}
						return (value/100000).toFixed(2);
					},
				},
				{ key: 'kwh', label: 'Kwh',
					formatter: (value) => { 
						
						return (value/100).toFixed(2);
					},
				},
				{ key: 'total_kw', label: 'Total KW',
					formatter: (value, key, item) => { 
						if(self.device.meter_type === '1P'){
							return (item.kw_r/10000).toFixed(3);
						}
						if(item.output_status == 0 && (parseInt(item.amp_r/1000) < self.$root.correction_amp && parseInt(item.amp_y/1000) < self.$root.correction_amp && parseInt(item.amp_b/1000) < self.$root.correction_amp)){
							value = 0;
						}
						return (value/100000).toFixed(2);
					},
				},
				{ key: 'update_time', label: 'TimeStamp',
					formatter: (value, key, item) => {
						var self = this;
						return self.$moment(item.update_time).format('DD-MM-YYYY HH:mm:ss');
					}, 
				},
				{ key: 'output_status', label: 'output', sortable: true },
				{ key: 'door_status', label: 'Door', sortable: true }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: []
		};
	},
	methods: {
		initload(){
			var self = this;
			self.axios.post(self.url, {
				accesskey: self.$session.get('access_key'),
				imeino: self.imeino
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.records;
					self.location = response.data.result.location;
					self.loading = false;
					self.totalRows = self.records.length;
					self.device = response.data.result.device;
					
					setTimeout(self.initload, self.$root.reload_duration);
				}else{
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "device_data_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table td, .table th{
	vertical-align: middle;
}
</style>